<template>
  <el-card>
    <h3>销售日报</h3>
  </el-card>
</template>

<script>
export default {
  name: 'SalesDaily'
}
</script>

<style scoped>

</style>
